export const queryKeys = {
  all: ["flagsmith"] as const,
  flags: ({ userId, email }: { userId?: string; email?: string }) =>
    [...queryKeys.all, "flags", userId, email] as const,
};
